<!-- eslint-disable no-unused-vars -->
<template>
  <div :class="[`backdrop ${isShowTariffsBlock ? 'show-backdrop' : ''}`]">
    <div
      :class="[
        `main-success-modal-block ${
          isShowTariffsBlock ? 'open-payment-info-block' : ''
        }`,
      ]"
    >
      <help-circle-icon class="success-icon-block" />
      <div class="success-title" v-html="formattedText"></div>
      <div class="buttons-container">
        <button @click="handlePayButton" class="success-tariff-button">
          {{ $t("homePage.payForTariff") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  //   CheckIcon,
  HelpCircleIcon,
} from "vue-feather-icons";

export default {
  name: "Question-block",
  components: {
    // CheckIcon,
    HelpCircleIcon,
  },
  props: {
    isShowTariffsBlock: {
      type: Boolean,
      require: true,
    },
    tariffsBlockMessage: {
      type: String,
      require: true,
    },
    openedCustomer: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      formattedText: "",
    };
  },
  async mounted() {},

  methods: {
    handlePayButton() {
      this.$emit("on-backdrop-click");
      this.$emit("on-use-animation", 5);
    },
  },
  computed: {},
  watch: {
    // eslint-disable-next-line no-unused-vars
    isShowTariffsBlock(newVal, oldVal) {
      this.formattedText = this.tariffsBlockMessage
        .replace(/\r/g, " ")
        .replace(/\n/g, "<br>");
    },
  },
};
</script>

<style scoped>
.main-success-modal-block {
  position: absolute;
  width: 70%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  opacity: 0;
  pointer-events: all !important;
  -webkit-backdrop-filter: saturate(180%) blur(80px);
  backdrop-filter: saturate(180%) blur(80px);
  background-color: rgba(255, 255, 255, 0.8);
  pointer-events: none;
  z-index: 0 !important;
  border: 0px !important;
  border-radius: 20px;
  transition: all 0.5s ease;
}

.open-payment-info-block {
  opacity: 1;
  z-index: 9999 !important;
}

.success-icon-block {
  margin: 0 auto;
  width: 50px;
  height: 50px;
  background: #f6bb42;
  color: #fff;
  border-radius: 50%;
  display: flex;
}
.success-icon {
  color: #fff;
  width: 40px;
  height: 40px;
  margin: auto;
}
.success-title {
  color: #1b1b1b;
  font-family: "Source Sans 3", sans-serif;
  line-height: 22px;
  font-weight: 700;
  letter-spacing: -0.6px;
  font-size: 15px;
  text-align: center;
  margin-top: 20px;
}
.success-text {
  text-align: center;
  color: #393939;
  font-family: "Source Sans 3", sans-serif;
  line-height: 20px;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0px;
}
.success-tariff-button {
  position: relative;
  font-family: "Source Sans 3", sans-serif;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 12px;
  font-size: 13px;
  padding: 14px 20px;
  width: 100%;
  color: #fff;
  font-size: 12px;
  margin-top: 20px;
  padding: 12px 18px;
  border: none;
  box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.1);
  transition: all 120ms ease;
  background-image: var(--main-bg-color);
  cursor: pointer;
}

.success-button.delete {
  background-image: linear-gradient(to bottom, #ed5565, #d84558);
}

.success-button::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.75) translateY(5px) translateZ(0px);
  filter: blur(8px);
}

.buttons-container {
  display: flex;
  justify-content: space-between;
}
</style>
